import { Ref } from "react";
import {
  CreatorFragmentCommonProps,
  CreatorFragmentHandle,
} from "@coworker/apprestructured/src/task-management/components/TaskCreatorAndEditorSheet/creator-fragments/CreatorFragment";
import LoadingCreatorFragment from "@coworker/apprestructured/src/task-management/components/LoadingCreatorFragment/LoadingCreatorFragment";
import { getByPath } from "@coworker/apprestructured/src/shared/helpers/object.helper";
import { ItemNoAndTypeWithPieces } from "@coworker/apprestructured/src/shared/types/item";
import { useAllAttachedItems } from "@coworker/apprestructured/src/task-management/services/useAllAttachedItems";
import { validateInitialDetailsFieldValue } from "@coworker/apprestructured/src/shared/helpers/schemaValidator";
import MultipleArticles from "../../../MultipleArticles/MultipleArticles";
import { LOADING } from "@coworker/apprestructured/src/task-management/loading";
import { isLoading } from "@coworker/apprestructured/src/task-management/loading";

export type ArticlesCreatorFragmentConfigProps = {
  field: string;
  maxArticles: number; // Maybe utilize later
};

type ArticlesCreatorFragmentProps = {
  configProps: ArticlesCreatorFragmentConfigProps;
  commonProps: CreatorFragmentCommonProps;
  ref?: Ref<CreatorFragmentHandle>;
};

function ArticlesCreatorFragment({
  configProps,
  commonProps,
}: ArticlesCreatorFragmentProps) {
  const { field /*maxArticles */ } = configProps;
  const { task, taskType } = commonProps;

  const itemNosAndTypeWithPieces = validateInitialDetailsFieldValue<
    ItemNoAndTypeWithPieces[]
  >(getByPath(task, field), field, taskType);

  const { items, isFetchingItems } = useAllAttachedItems(
    itemNosAndTypeWithPieces ?? LOADING
  );

  const selectedItems = Array.isArray(itemNosAndTypeWithPieces)
    ? itemNosAndTypeWithPieces
    : [];

  const piecesByItemNo = new Map(
    selectedItems.map(({ no, pieces }) => [no, pieces ?? 0])
  );

  const articles = items.map((item) => ({
    ...item,
    pieces: piecesByItemNo.get(item.no) ?? 0,
  }));

  if (isFetchingItems || isLoading(itemNosAndTypeWithPieces)) {
    return <LoadingCreatorFragment />;
  }

  return <MultipleArticles articles={articles} />;
}

export default ArticlesCreatorFragment;
